import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';

@Component({
  selector: 'app-channel-default-page',
  templateUrl: './channel-default-page.component.html',
  styleUrls: ['./channel-default-page.component.scss']
})

export class ChannelDefaultPageComponent implements OnInit {
  settingsData: any = {};
  org_info: any;
  settingsDataSubscription: Subscription;

    constructor(
      private commanSubscribeService: CommanSubscribeService,
    ) {
      this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    }
  ngOnInit() {
    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe((response) => {
      this.settingsData = response;
    });
  }


}
